import { Breadcrumb, HeaderToolbar } from "@xola/ui-kit";
import React from "react";
import { ColumnLayout } from "../../components/Layout/ColumnLayout";
import { PayoutFilter } from "../../components/Reports/Payouts/PayoutFilter";
import { PayoutSummary } from "../../components/Reports/Payouts/PayoutSummary";
import { PayoutTable } from "../../components/Reports/Payouts/PayoutTable";
import { Page } from "../Page";

export const PayoutPage = () => {
    return (
        <Page title="Payout">
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb className="truncate border-r-0">
                        <Breadcrumb.Item>Reports</Breadcrumb.Item>
                        <Breadcrumb.Item>Payouts</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>
                </HeaderToolbar>

                <PayoutFilter />
                <PayoutSummary />

                <ColumnLayout.Fill>
                    <div className="px-6 pt-3 pb-20">
                        <PayoutTable />
                    </div>
                </ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
